// This file is generated by pnpm icons:generate. Do not edit.

import {SpeakerVolumeFull_Stroke2_Corner0_Rounded as CanonicalSpeakerVolumeFull_Stroke2_Corner0_Rounded} from './SpeakerVolumeFull'

/** @deprecated Import SpeakerVolumeFull_Stroke2_Corner0_Rounded from `#/components/icons/SpeakerVolumeFull` instead. */
export const SpeakerVolumeFull_Stroke2_Corner0_Rounded =
  CanonicalSpeakerVolumeFull_Stroke2_Corner0_Rounded
